import React from 'react';
export const HoneypotSetFormContext = React.createContext(); 